

export const WIDGET_ELEM_someReqPropsUnset = widgetConfig => {
    return !widgetConfig?.props?.dimension1 && !widgetConfig?.props?.dimension2
  }
  
